import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-gold/40 bg-steel py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-63" data-mp="12slodzpkpx35">
      <div className="mx-auto max-w-4xl px-4" data-id="element-64" data-mp="xt91xg2m6s13">
        <div className="text-center" data-id="element-65" data-mp="xsfqw2wmhgd5">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-66" data-mp="1cqrnyanwqr4u">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 text-2xl font-extrabold text-mineral sm:text-3xl" data-id="element-67" data-mp="17q3wjnvro8a3">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-68" data-mp="1hjuk8qk2keoq">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-gold bg-navy/60 px-4 py-3 text-sm font-semibold text-white" data-id="element-69" data-mp="1vf6e6vqei14l" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-mineral" aria-hidden="true" data-id="element-70" data-mp="2gcn0y01tctqx" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-71" data-mp="2l93zlo6n2qi9">
          <p className="leading-relaxed text-muted" data-id="element-72" data-mp="2q9055ruzipzx">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-73" data-mp="300mcve8466xx">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}